import { AggregateError } from "../Error";

export function sleepAsync(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function deferred() {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return [promise, resolve,reject];
}

export function AllProcessSettled(...promises) {
    const [promise, res, rej] = deferred();
    Promise.allSettled(promises).then((operationResult) => { 
        const result = [], errors = [];
        operationResult.forEach(item => {
            if (item.status === "rejected") {
                if (item.reason.isAggregate) {
                    if (Array.isArray(item.reason.errors)) {
                        item.reason.errors.forEach(err => {
                            errors.push(err);
                        });
                    }
                    if (Array.isArray(item.reason.data)) {
                        result.push(...item.reason.data);
                    }
                } else {
                    errors.push(item.reason);
                }
            } else if (item.status === "fulfilled") {
                result.push(item);
            }
        });
        if (errors.length) {
            const aggregateError = AggregateError(errors, "One or more changes failed to process");
            aggregateError.data = result;
            rej(aggregateError);
        } else {
            res(result);
        }

    });
    return promise;
}


export function deferCall(cb) {
    const [promise, resolve, reject ] = deferred();
    if (typeof cb === "function") {
        promise.timeout = setTimeout(() => {
            try {
                resolve(cb());
            } catch (error) {
                reject(error);
            }
        }, 50);
    }
    return promise;
}
